import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import TruncatedText from "shiitake";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCardAloha, UitkCardAlohaContentSection, UitkCardAlohaLink } from "uitk-react-cards";

import { getAuthorFromCityStayedAtHotelText, getPostedAgoText, ratingDescription } from "../../hotelRecentReviewsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import {
  HotelRecentReviewsFlexModuleResult,
  HotelReview,
} from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const HeaderImageCard = (props: { model: HotelRecentReviewsFlexModuleResult; hotel: HotelReview }) => {
  const { model, hotel } = props;
  const { showTitleOfReviewForHeaderImageView } = model;
  const {
    hotelName,
    hotelImageUrl,
    hotelInfositeUrl,
    date: reviewPostedDate,
    rating,
    reviewTitle,
    reviewText,
    authorName,
    authorLocation,
  } = hotel;

  const { formatText } = useLocalization();

  return (
    <UitkCardAloha>
      <UitkFigure ratio={UitkFigure.AspectRatio.R21_9}>
        <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage={true} />
        <UitkScrim>
          <UitkText size={700} weight="bold" className="truncate-lines-2">
            {hotelName}
          </UitkText>
        </UitkScrim>
      </UitkFigure>
      <UitkCardAlohaContentSection>
        <UitkLayoutFlex direction="column">
          <UitkText className="uitk-type-heading-400 all-b-margin-two">
            {formatText("hotelRecentReviews.ratingSlashNoSpace", rating)} {ratingDescription(rating)}
          </UitkText>
          {showTitleOfReviewForHeaderImageView && (
            <UitkText className="uitk-type-heading-300 all-b-margin-two">{reviewTitle}</UitkText>
          )}
          <TruncatedText
            lines={2}
            renderFullOnServer={true}
            overflowNode={"\u2026\u0022"}
            className="uitk-type-heading-300 all-b-margin-two"
          >
            {`\u0022${reviewText}\u0022`}
          </TruncatedText>
          <UitkText size={200} className="truncate-lines-2 all-b-margin-two">
            {getAuthorFromCityStayedAtHotelText(authorName, authorLocation, hotelName)}
          </UitkText>
          <UitkText size={200}>{getPostedAgoText(reviewPostedDate)}</UitkText>
        </UitkLayoutFlex>
      </UitkCardAlohaContentSection>
      <UitkCardAlohaLink>
        <TrackedLink
          moduleName="hotelRecentReviews"
          rfrr="hotelInfositeLink"
          href={hotelInfositeUrl}
          data-testid={`hotel-recent-reviews-header-image-card-${hotelName}`}
        >
          {hotelName}
        </TrackedLink>
      </UitkCardAlohaLink>
    </UitkCardAloha>
  );
};

export default HeaderImageCard;
